import {toggle_loader, disable_loader} from '../_loader';
import {clear_cart, update_cart} from './_cart';

document.addEventListener("DOMContentLoaded", function() {

	//prepare the click event
	document.addEventListener('click', function (event) {
	
		//if the clicked element triggers the rebuy process
		if (event.target.matches('#purchase-again')) {

			//prevent this button doing anything
			event.preventDefault();

			let order_items = document.getElementsByClassName('order-item');

			if(order_items && order_items.length > 0) {
				
				//bring up the loading bar
				toggle_loader();

				//empty the cart
				clear_cart();

				//loop over each order item
				for(let i = 0; i < order_items.length; i++) {

					//store the order data as its own object
					let item = order_items[i];

					//add it to the cart
					update_cart(item.dataset.id, item.dataset.quantity, item.dataset.type)

					//redirect the user to the cart
					window.location.href = '/shopping-cart';
				}
			}
		}
	});
}); 